import { Injectable } from '@angular/core';
import { OnPremiseProvider } from './on-premise';

@Injectable()
export class DownloadProvider {
    constructor(private onPremiseProvider: OnPremiseProvider) {}

    public async download(url: string) {
        if (this.onPremiseProvider.isOnPremiseElectronApp()) {
            await this.onPremiseProvider.downloadUrl(url);
        } else {
            window.location.href = url;
        }
    }
}



// WEBPACK FOOTER //
// ./src/providers/download.ts